import React, { useEffect, useRef } from 'react';
import ejBg from '../../assets/images/el-jefe/ej-bg.png';
import ejTm from '../../assets/images/el-jefe/ej-tm.png';
import ejLeft from '../../assets/images/el-jefe/ej-left.png';
import ejRight1 from '../../assets/images/el-jefe/ej-right-1.png';
import ejRight2 from '../../assets/images/el-jefe/ej-right-2.png';

const ElJefeSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const img1Ref = useRef<HTMLImageElement>(null);
  const img2Ref = useRef<HTMLImageElement>(null);
  const img3Ref = useRef<HTMLImageElement>(null);
  const img4Ref = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const images = [img1Ref.current, img2Ref.current, img3Ref.current, img4Ref.current];
    images.forEach((img) => {
      if (img) observer.observe(img);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="el-jefe" className="w-full relative" style={{ backgroundColor: '#000000' }}>
      <style>{`
        .ej-float {
          opacity: 0;
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }
        .ej-float.visible {
          opacity: 1;
        }
        .ej-float.top-left {
          transform: translateY(-40px) translateX(-40px);
          transition-delay: 0.2s;
        }
        .ej-float.top-left.visible {
          transform: translateY(0) translateX(0);
        }
        .ej-float.bottom-left {
          transform: translateY(40px) translateX(-40px);
          transition-delay: 0.5s;
        }
        .ej-float.bottom-left.visible {
          transform: translateY(0) translateX(0);
        }
        .ej-float.bottom-right-1 {
          transform: translateY(40px) translateX(40px);
          transition-delay: 0.8s;
        }
        .ej-float.bottom-right-1.visible {
          transform: translateY(0) translateX(0);
        }
        .ej-float.bottom-right-2 {
          transform: translateY(40px) translateX(40px);
          transition-delay: 1.1s;
        }
        .ej-float.bottom-right-2.visible {
          transform: translateY(0) translateX(0);
        }
      `}</style>

      <div
        ref={sectionRef}
        className="relative w-full overflow-hidden"
        style={{
          maxWidth: '1920px',
          margin: '0 auto',
        }}
      >
        {/* Background Image - full like banner */}
        <img
          src={ejBg}
          alt="El Jefe Background"
          className="w-full block max-w-full h-auto"
        />

        {/* Floating Image - Top Left (Badge) */}
        <img
          ref={img1Ref}
          src={ejTm}
          alt="Grill Me Crazy Badge"
          className="ej-float top-left absolute"
          style={{
            width: 'clamp(60px, 15vw, 320px)',
            height: 'clamp(60px, 15vw, 320px)',
            top: 'clamp(6px, 1.5vw, 40px)',
            left: 'clamp(0.5rem, 1.5vw, 3rem)',
          }}
        />

        {/* Floating Image - Bottom Left (The Crazy Keeper) */}
        <img
          ref={img2Ref}
          src={ejLeft}
          alt="The Crazy Keeper of GMC"
          className="ej-float bottom-left absolute"
          style={{
            width: 'clamp(100px, 22vw, 407px)',
            height: 'clamp(54px, 12vw, 218px)',
            bottom: 'clamp(40px, 10vw, 180px)',
            left: 'clamp(10px, 4vw, 120px)',
          }}
        />

        {/* Floating Image - Bottom Right Top (Who is El Jefe) */}
        <img
          ref={img3Ref}
          src={ejRight1}
          alt="Who is El Jefe"
          className="ej-float bottom-right-1 absolute"
          style={{
            width: 'clamp(110px, 25vw, 490px)',
            height: 'clamp(36px, 8vw, 160px)',
            bottom: 'clamp(65px, 15vw, 280px)',
            right: 'clamp(10px, 4vw, 120px)',
          }}
        />

        {/* Floating Image - Bottom Right Bottom (The Rules) */}
        <img
          ref={img4Ref}
          src={ejRight2}
          alt="The Rules"
          className="ej-float bottom-right-2 absolute"
          style={{
            width: 'clamp(95px, 22vw, 430px)',
            height: 'clamp(32px, 7vw, 143px)',
            bottom: 'clamp(10px, 3vw, 96px)',
            right: 'clamp(15px, 6vw, 178px)',
          }}
        />
      </div>
    </section>
  );
};

export default ElJefeSection;
